import { motion } from "framer-motion";
import { IMAGES } from "@/lib/api";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 bg-[#efe1cd] overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_20px_60px_rgba(156,85,96,0.2)]">
            <img src={IMAGES.about} alt="Rose and lotus mandala" className="w-full object-cover" />
          </div>
          <img src={IMAGES.portal} alt="" className="absolute -bottom-10 -right-8 w-40 opacity-70 animate-float pointer-events-none" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-accent text-sm tracking-widest-2 uppercase text-[#c2a04b] mb-4">The guide</p>
          <h2 className="font-display text-4xl md:text-5xl text-[#3a2630] leading-tight">Meet Laura Lee Thayer</h2>
          <p className="text-[#3a2630]/75 mt-6 leading-relaxed">
            I am Laura Lee Thayer — a guide devoted to the unfolding of harmonic consciousness.
            More than anything, my heart's work is to help people find their <span className="text-[#9c5560] italic">sovereignty</span> —
            to remember they are free, whole, and the sole author of their own field.
          </p>
          <p className="text-[#3a2630]/75 mt-4 leading-relaxed">
            Through 432 Hz music, light language, and presence, I offer guided support so you can
            calm your nervous system, awaken soul remembrance, and align with your original resonance.
            Rosefield Harmonic is a living sanctuary for those walking the heart-led path of return.
          </p>

          <div className="mt-8 space-y-3">
            {[
              "Reclaim your sovereignty",
              "Calm your nervous system",
              "Awaken your soul remembrance",
              "Align with your original resonance",
            ].map((item) => (
              <div key={item} className="flex items-center gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#b76e79]" />
                <span className="text-[#3a2630]/80 font-accent">{item}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
